import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ReducedProfile } from '@interfaces/profiles/reduced-profile';
import { AuthService } from '@services/auth.service';
import { ProfileService } from '@services/profile.service';
import { of, switchMap, map } from 'rxjs';

export const ProfileSelectorGuard: CanActivateFn = (
    route,
    state,
    profileSrv = inject(ProfileService),
    authSrv = inject(AuthService)
) => {
    return profileSrv.getUserProfiles().pipe(
        switchMap((result: ReducedProfile[]) => {
            if (result.length === 1) {
                return authSrv.setCurrentProfile(result[0]).pipe(
                    map(() => false as const)
                );
            }
            return of(true as const);
        })
    );
};
